<template>
    <b-card no-body :header="name+'的個性分析'" class="mb-2" border-variant="primary" header-bg-variant="primary" header-text-variant="white">
        <b-list-group flush v-if="Vipstatus">
            <b-list-group-item v-for="(item , index) in listdata" v-bind:key="index"><img class="redS" :src="require('../assets/ui/red.png')"> {{ item.result }}</b-list-group-item>
        </b-list-group>

        <b-overlay v-else :show="true" opacity="0.5" rounded="sm" >
            <b-list-group flush style="color: transparent;text-shadow:2px 2px 12px #000000;">
                <b-list-group-item v-for="(item , index) in randText" v-bind:key="index"><img class="redS" :src="require('../assets/ui/red.png')"> {{ item.result }}</b-list-group-item>
            </b-list-group>
            <template v-slot:overlay>

                <b-button pill variant="primary" size="lg" @click="callaction">  <b-icon icon="lock-fill"></b-icon>解鎖本人個性</b-button>
            </template>
        </b-overlay>

    </b-card>

</template>
<script>
import {mapState} from 'vuex'

export default {
  name: 'PersonYearResultCard',
  props: {
    Vipstatus:Boolean,
    listdata: Array,
    allyear: Array,

  },
  computed:{
    ...mapState(['profiledata']),
    name:function () {return this.profiledata !==null ? this.profiledata.first_name+this.profiledata.last_name : '';},
  },
  data () {
    return {
      randText:[
        {result:'不是吧棯虮扠燔艅廥彴一軴啍瓵杸刉厙丌，嗍嵑乇妵牁葌徂氶屮芫蓒峉尐怐，气疺呤娸狪岢佸抎裚屮玬慲溗。'},
        {result:'愅呫犴橏裬尻洢亍，遄偨兀岣秏腩佮圢屮皯睾柟圠岠。胾呴邗諟嵊嬖汌一袲堈袟杺尒恟丌，鉖棪屮岯丌岰禒姴气泒。'},
        {result:'棯虮扠燔艅瓵杸刉厙丌，气疺呤娸狪鸁葯歈屻夼挌芓岢佸抎裚屮玬慲溗。'},
        {result:'愅呫犴橏裬踶朼枘尻洢亍，遄偨兀岣秏腩佮圢屮皯睾柟圠岠。胾呴邗諟嵊嬖汌一袲堈袟杺尒恟丌。'},
        {result:'捑一胅唲罦銃亍誋擳勼，脙亍拏桭堭搊亍嘝殳氻。祫一斪剬跖鳧乇墿仂，偳屮苖掎堷楘乜僣冘仜。'}
      ]
    }
  },
  methods: {
    callaction () {

      this.$emit('sendAction');
    },
  }
}
</script>
